module.exports = __webpack_public_path__ + "static/media/2019_conf_Netflixs_Customer_Obsession.337526d9.png";